import SpinGridComponent from './spinGrid.component'

export default SpinGridComponent